import { RadioGroup, Radio } from '@trackman/web-shared-components';
import { selectOptionType } from 'types/GlobalTypes';

type AppRadioProps = {
  value: string;
  options: Array<selectOptionType>;
  onChange: (value: string) => void;
  isDisabled?: boolean;
  margin?: string;
  width?: string;
};

const AppRadioGroup = ({ value, options, onChange, isDisabled = false, width = '90px', margin = '0' }: AppRadioProps) => {
  return (
    <>
      <RadioGroup
        aria-label='scoreboardConfiguration.unitSystem'
        name='scoreboardConfiguration.unitSystem'
        className='d-flex'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-test='testing-radio-group'
      >
        {options.map((option, index) => (
          <Radio
            key={index}
            value={option.value}
            label={option.label}
            width={width}
            margin={margin}
            reversed
            disabled={isDisabled}
            checked={value === option.value}
          />
        ))}
      </RadioGroup>
    </>
  );
};

export default AppRadioGroup;
